import Link from 'next/link';
import { useTranslation } from "next-i18next";
import moment from 'moment';
import hooks from "./SelectedMasterHook";
import Rating from '../Rating';
import styles from "../../styles/Masters2.module.scss";
import translate_word from "../../utils/translate";
import { master_address_select, master_schedule } from '../../store/actions/master';

function SelectedMastersMobile(props) {
    const { location, router, getDistance,dispatch } = hooks(props);
    const service_sorted_list = props.profession?.sort((a, b) => b.price - a.price);
    const { t, i18n } = useTranslation();
    const handleChange = (day) => {
        dispatch(master_address_select({ selected_service: service_sorted_list[0].service_id }));
        dispatch(master_schedule({
            calendar_value: {
                day: day.getDate(),
                month: day.getMonth() + 1,
                year: day.getFullYear()
            }
        }));
        router.push(`/master/${props?.id}/register-master/?free_day=${moment(day).format('YYYY-MM-DD')}&service=${service_sorted_list[0].service_id}`);
    };
    return (
        <Link as={`/${props.language}/master/${props.id}`}
            href={`/${props.language}/master/${props.id}`}>
            <a>
                <div className={styles.card_masters_mobile}>
                    <div className="d-flex justify-content-between">
                        <div className="d-flex">
                            {/* <Link as={`/${props.language}/master/${props.id}`}
                        href={`/${props.language}/master/${props.id}`}>
                        <a> */}
                            <img src={props.image} />
                            {/* </a>
                    </Link> */}
                            <div className="d-flex flex-column mobile-map-label">
                                <div className={`${styles.name_container} d-flex justify-content-between`}>
                                    <span className={styles.name}>
                                        {props?.first_name?.length > 0 ? `${props?.first_name} ${props?.last_name}` : props?.username}
                                    </span>
                                    <div className={styles.mobile_price}>
                                        {props.profession && service_sorted_list && service_sorted_list.length > 0 && <span>{t("priceFromMaster")}{service_sorted_list[service_sorted_list?.length - 1]?.price}€
                                            {t("priceToMaster")}{service_sorted_list[0]?.price}€</span>}
                                        {location
                                            ? <span className={styles.master_location}><i className="icon-map-label"></i><span>
                                                {location} {t("km")}</span></span>
                                            : null}
                                    </div>
                                </div>

                                <div className="d-flex">
                                    <Rating name="disabled" disabled
                                        value={props.rating} size="small" />
                                    <div className={styles.review_count}>
                                        {props.review_count} {t("reviewLabel")}
                                    </div>
                                </div>

                                <span className={styles.profession}>
                                    {props?.profession
                                        ?.map((el, ind) => {
                                            if (ind < 3) {
                                                return <span key={ind} >
                                                    {el?.service_name_en}
                                                    {ind !== 2 || props.profession.length - 1 !== 2 ? "," : ""}
                                                </span>;
                                            }
                                        })}</span>

                                {/* {props.loc && <span className={styles.location}>
                            <i className="icon-map-label"></i>
                            {props.loc}
                        </span>} */}


                            </div>

                        </div>

                        <div className="d-flex flex-column align-items-end">
                            <div className={styles.price_location}>
                                {/* <span>€ {service_sorted_list[service_sorted_list.length - 1].price}
                            -{service_sorted_list[0].price}</span>
                        {location
                            ? <span className={styles.master_location}><i className="icon-map-label"></i><span>
                                {location} {t("km")}</span></span>
                            : null} */}
                                {/* <div className={props.selected ? "my-master" : "any-master"}>
                            <i className="icon-heart"
                                onClick={() => props.add_favorite_masters()}
                                style={{ color: props.selected ? "#F99A9E" : "#A4A4A4" }}></i>
                        </div> */}
                            </div>
                        </div>

                    </div>
                    <div className={styles.address_cont}>
                        {props.single_address && <p className="d-flex justify-content-between card-map-label">
                            <div className='d-flex align-items-center'>
                                <i className="icon-map-label"></i>
                                {props.single_address}
                            </div>
                            <span className={styles.distance}>{props.geolocation && getDistance({ lat: props.lat, lng: props.lng }, { lat: props.address.lat, lng: props.address.lng })}km</span>
                        </p>}
                        {props?.loc?.map((address, index) => <p className="d-flex justify-content-between card-map-label" key={index}>
                            <div className='d-flex align-items-center'><i className="icon-map-label"></i>
                                {address?.name}</div>
                            <span className={styles.distance}>{props.geolocation && getDistance({ lat: props.lat, lng: props.lng }, { lat: address.latitude, lng: address.longitude })}km</span>
                        </p>)}
                    </div>
                    <div className={`${styles.profession} mt-3`}>{t("nextAvailabilities")}</div>
                    <div className='d-flex flex-wrap'>
                        {props?.next_free_days?.map((el, ind) => {
                            moment.locale(i18n.language);
                            const d = new Date(el);
                            const day_with_format = moment(d).format('DD MMMM');
                            const weekday = moment(d).format('ddd');
                            return <div key={ind}
                                onClick={(e) => {
                                    e.preventDefault()
                                    handleChange(d)
                                }}
                                className={`mt-1 ${styles.next_date}`}>{weekday} {day_with_format}</div>;
                        })}
                    </div>
                </div>
            </a>
        </Link>
    );
};
export default SelectedMastersMobile;